import { useTranslation } from 'react-i18next'

import { UrlLink } from './url-link.component'
import { HelperWrapper } from 'src/components'
import useStyles from './styles'

interface IProps {
  qrLink: string | null
  overrideUrl: string | null
  label?: string
}

export const ProductCodeUrls = ({ qrLink, overrideUrl, label }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.urlsWrapper}>
      <UrlLink
        withCopy
        title={
          <HelperWrapper
            t={label ? label : 'qr-code-landing-url'}
            verticalPosition={10}
            size={11}
            isColorInherited
          />
        }
        link={qrLink}
      />
      <UrlLink
        title={
          <HelperWrapper
            t="qr-code-override-url"
            verticalPosition={10}
            size={11}
            isColorInherited
          />
        }
        link={overrideUrl}
      />
    </div>
  )
}
